export default __webpack_public_path__ + "static/media/logo.ba7d3e6f.png";